import { ReduxHelper } from "helpers";

export const prefix = "ERROR";

const clearError = ReduxHelper.generateLocalAction(`${prefix}/CLEAR_ERROR`);

export { clearError };
